export default {
  role_hierarchy: {
    ROLE_ADMIN: 'ROLE_MANAGER',
    ROLE_MANAGER: 'ROLE_RECRUITER',
    ROLE_RECRUITER: 'ROLE_USER',
    ROLE_USER: 'ROLE_ANONYMOUS',
  },
  access_control: [
    { path: '^/', methods: ['OPTIONS'], roles: 'ROLE_ANONYMOUS' },
    { path: '^/$', roles: 'ROLE_ANONYMOUS' },
    { path: '^/api/$', roles: 'ROLE_ANONYMOUS' },
    { path: '^/api/public', roles: 'ROLE_ANONYMOUS' },
    { path: '^/api/doc/default', roles: 'ROLE_DOC' },
    { path: '^/api/authenticate', roles: 'ROLE_ANONYMOUS' },
    { path: '^/api/logout.json', roles: 'ROLE_USER' },
    { path: '^/api/user.json', roles: 'ROLE_USER' },
    {
      path: '^/api/clients/(\\d+)/campaigns/(\\d+)/settings',
      roles: ['ROLE_ADMIN'],
      methods: ['POST'],
    },
    {
      path: '^/api/clients',
      methods: ['OPTIONS', 'GET'],
      roles: ['ROLE_USER'],
    },
    { path: '^/api/clients', roles: 'ROLE_ADMIN' },
    {
      path: '^/api/locations',
      methods: ['OPTIONS', 'GET'],
      roles: ['ROLE_USER']
    },
    { path: '^/api/locations', roles: 'ROLE_ADMIN' },
    {
      path: '^/api/employees/(.*)/password',
      roles: 'ROLE_MANAGER',
      methods: ['PATCH'],
    },
    {
      path: '^/api/employees/',
      roles: 'ROLE_ADMIN',
      methods: ['DELETE'],
    },
    { path: '^/api/employees/(.*)/anomyze', roles: 'ROLE_ADMIN' },
    {
      path: '^/api/employees',
      roles: ['ROLE_RECRUITER'],
      methods: ['POST', 'GET', 'PUT'],
    },
    {
      path: '^/api/users/',
      roles: 'ROLE_ADMIN',
      methods: ['DELETE'],
    },
    {
      path: '^/api/users',
      roles: ['ROLE_MANAGER'],
      methods: ['POST', 'GET', 'PUT'],
    },
    {
      path: '^/api/calllogs',
      roles: ['ROLE_RECRUITER'],
      methods: ['GET'],
    },
    {
      path: '^/api/notifications',
      roles: ['ROLE_RECRUITER'],
    },
    { path: '^/api/autocomplete', roles: 'ROLE_USER' },
    { path: '^/api/messagebird/proxy', roles: 'ROLE_USER' },
    {
      path: '^/api/twilio/dail_event/.*',
      roles: 'ROLE_ANONYMOUS',
      methods: ['POST'],
    },
    { path: '^/api/twilio', roles: 'ROLE_RECRUITER' },
    { path: '^/', roles: 'ROLE_ADMIN' },
  ],
};
